<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-lg-flex justify-content-between">
        <div class="statCard green mr-4">
          <span>En cours</span>
          <span class="statNumber">{{statistics.hospitalizations}}</span>
        </div>
        <div class="statCard pink mt-2 mt-lg-0 mr-4">
          <span>Départs</span>
          <span class="statNumber">{{statistics.toReturn}}</span>
        </div>
        <div class="statCard red mt-2 mt-lg-0">
          <span>Terminées</span>
          <span class="statNumber">{{statistics.finished}}</span>
        </div>
      </div>


      <div class="mt-4 d-flex flex-column flex-md-row align-items-md-start justify-content-md-between align-items-start">
        <div class="mb-0">
          <h1 class="page-title">Hospitalisations</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
          <b-button variant="secondary" @click="clickOnCreateAlternativeBtn" class="mb-2 mb-lg-0 mr-lg-2 w-100 w-lg-auto text-nowrap">
            <plus-icon size="18" class="mr-1" /> Ajouter un animal
          </b-button>
          <b-button variant="primary" @click="clickOnCreateBtn" class="w-100 w-lg-auto text-nowrap">
            <plus-icon size="18" class="mr-1" /> Ajouter une hospitalisation
          </b-button>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableHospitalization"
          identifier="B122TableHospitalization"
          init-b122-table-url="/hospitalization/initB122Table"
          get-b122-table-results-url="/hospitalization/getB122TableResults"
          :fields="tableFields"
          initial-sort-by="animal.user.lastName"
          :initial-sort-desc="false"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >
          <template #cell(toReturn)="data">
            <sun-icon size="20" v-if="data.item.toReturnToday"></sun-icon>
            <moon-icon size="18" v-if="data.item.toReturnTonight"></moon-icon>
          </template>
        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <hospitalization-delete-modal :selectedHospitalization="ui.selectedHospitalization" @didDeleteHospitalization="didDeleteHospitalization()"></hospitalization-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import B122Table from "../../components/b122/B122Table";
import HospitalizationDeleteModal from "./HospitalizationDeleteModal";
import TimeUtils from "../../utils/TimeUtils";

export default {

  name: 'HospitalizationIndex',

  components: {
    B122Table,
    HospitalizationDeleteModal
  },

  data() {
    return {

      totalCount: 0,
      statistics: {
        hospitalizations:0,
        toReturn:0,
        finished:0
      },

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },

        {
          label: "Propriétaire",
          key: "animal.user.name",
          sortKey: "animal.user.lastName",
          sortable: true
        },
        {
          label: "Animal",
          key: "animal.name",
          sortable: true
        },
        {
          label: "Espèce",
          key: "animal.species.name",
          sortable: true
        },
        {
          label: "Motif",
          key: "goal",
          sortable: true
        },
        {
          label: "État de santé",
          key: "dailyStatuses.healthState.name",
          sortable: false
        },
        {
          label: "Dernier état quotidien",
          key: "dailyStatuses.lastPublicationDate",
          sortable: false,
          formatter: function (value, key, item) {
            if(value == null){
              return ""
            }
            return new Date(value).toLocaleString("fr-FR", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: "2-digit" })
          }
        },
        {
          label: "Estimation de sortie",
          key: "presumedEndDate",
          sortable: false,
            formatter: function (value, key, item) {
              return TimeUtils.nbOfDaysBeforePresumedEndDate(value)
            }
        },
        {
          label: "Récup.",
          key: "toReturn"
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedHospitalization: null
      }
    }
  },

    mounted(){
        this.fetchStats();
    },

    methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    fetchStats(){
        api
            .get(`/hospitalization/getStatsForIndex`)
            .then(response => {
                this.statistics.hospitalizations = response.data.hospitalizationsCount[0]
                this.statistics.toReturn = response.data.toReturnCount[0]
                this.statistics.finished = response.data.finishedCount[0]
            })
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'HospitalizationCreate'
      })
    },

    clickOnCreateAlternativeBtn () {
      this.$router.push({
        name: 'UserCreate',
        params: {
          createHospitalization: true
        }
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'HospitalizationShow',
        params: {
          hospitalizationId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'HospitalizationEdit',
        params: {
          hospitalizationId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedHospitalization = row.item
      this.$bvModal.show('hospitalization-delete-modal')
    },

    didDeleteHospitalization() {
      this.ui.selectedHospitalization = null;
      this.$refs.B122TableHospitalization.refreshTable()
    }

  }
}
</script>

<style scoped>
  .statCard{
    width: 50%;
    padding: 12px 20px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--main-white);
    font-size: var(--title-level-one-font-size);
    font-weight: bold;
    word-break: break-word;
  }
  @media (max-width: 992px) {
    .statCard {
      width: 100%;
    }
  }
  .statNumber{
    font-family: var(--font-family-heading);
    font-size: 40px;
    font-weight: bold;
  }
  .red{
    background-color: var(--secondary-color);
  }
  .green{
    background-color: var(--main-green);
  }
  .pink{
    background-color: var(--main-color);
  }
</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationIndex.vue